/**
 * Created by andrey on 20.11.17.
 */

cleverapps.Plot = {
    onStartup: function (f, returnClassOnly) {
        if (levels.user.currentPhysicalLevel.episode === 0 && levels.user.currentPhysicalLevel.level === 0) {
            return this.onFirstInit(f, returnClassOnly);
        } 
        if (returnClassOnly) {
            return cleverapps.meta.getMainScene();
        }
        cleverapps.meta.gotoMainLocation(f);
    },

    onFirstInit: function (focus, returnClassOnly) {
        const actions = [];

        if (cleverapps.styles.comicses && cleverapps.styles.comicses.begin) {
            if (returnClassOnly) {
                return {
                    scene: bundles.main.jsons.comicsscene_prefab_json,
                    options: [cleverapps.styles.comicses.begin]
                };
            }
            actions.push((f) => {
                ComicsScene.showComics(f, cleverapps.styles.comicses.begin);
            });
        } else if (this.hasStartEpisodeWindow()) {
            if (returnClassOnly) {
                return cleverapps.meta.getMainScene();
            }
            actions.push((f) => {
                cleverapps.meta.gotoMainLocation(f);
            });
            actions.push((f) => {
                this.onStartEpisode(f, {
                    episodeNo: cleverapps.meta.selectedLocationId()
                });
            });

            cleverapps.focusManager.compound(focus, actions);
            return;
        }

        if (["simple", "hose"].indexOf(cleverapps.meta.getSelectedLocation().locationConfig.locationType) !== -1) {
            if (returnClassOnly) {
                return {
                    scene: GameScene,
                    options: [{ level: new Level(0, 0) }]
                };
            }
            actions.push((f) => {
                if (cleverapps.lives) {
                    cleverapps.lives.reset();
                }
                Level.WantsToPlay(f, {
                    interstitial: false
                });
            });
        } else {
            if (returnClassOnly) {
                return cleverapps.meta.getMainScene();
            }
            actions.push((f) => {
                cleverapps.meta.gotoMainLocation(f);
            });
        }

        cleverapps.focusManager.compound(focus, actions);
    },

    hasStartEpisodeWindow: function () {
        return cleverapps.config.name === "riddles";
    },

    onStartEpisode: function (f, options) {
        const location = cleverapps.meta.getSelectedLocation();
        if (location.isLocationCompleted && location.isLocationCompleted()) {
            new FinisherWindow();
            cleverapps.focusManager.onceNoWindowsListener = f;
        } else if (this.hasStartEpisodeWindow()) {
            new StartEpisodeWindow(options.episodeNo);
            cleverapps.focusManager.onceNoWindowsListener = f;
        } else {
            f();
        }
    },

    getDialogueAfterLevel: function (level) {
        if (!cleverapps.styles.dialogues || !level.isRegular()) {
            return false;
        }

        const passedNo = cleverapps.user.getHumanReadableNumber() - 1;
        return cleverapps.styles.dialogues[`finishLevel${passedNo}`];
    },

    finishLevelDialogue: function (f, level) {
        const styles = this.getDialogueAfterLevel(level);
        if (!styles) {
            return;
        }

        const scene = cleverapps.Scenes.GetRunningScene();

        cleverapps.focusManager.compound(f, [
            function (f) {
                if (styles.bundles) {
                    const load = function (retries = 0) {
                        cleverapps.loading.show();

                        cleverapps.bundleLoader.loadBundles(styles.bundles, {
                            onSuccess: function () {
                                cleverapps.loading.hide();
                                f();
                            },
                            onFailure: function (errors) {
                                cleverapps.focusManager.display({
                                    focus: "LoadFailureRestartWindow",
                                    stack: true,
                                    action: function (freeFocus) {
                                        cleverapps.loading.hide();

                                        ErrorHandler.showRestartWindow({
                                            errors,
                                            retries,
                                            onRetry: function () {
                                                freeFocus();
                                                cleverapps.bundleLoader.deleteBundles(styles.bundles);
                                                load(retries + 1);
                                            }
                                        });
                                    }
                                });
                            }
                        });
                    };

                    load();
                } else {
                    f();
                }
            },
            function (f) {
                const scale = 1.2;
                const dy = scene.height * (scale - 1);
                scene.sceneComponent.createFilmEffect({
                    scale,
                    layerTimeout: 0.3,
                    scaleTimeout: 1,
                    moveBy: { y: dy },
                    onShow: f
                });
            },
            function (f) {
                const dialogue = new Dialogue(styles.dialogue, {
                    autoClose: true,
                    autoScroll: 3,
                    parentScene: true,
                    showUp: true
                });
                dialogue.on("afterClose", f);

                const dialogueView = new DialogueView(dialogue);
                dialogueView.setLocalZOrder(51);
            },
            function (f) {
                scene.sceneComponent.removeFilmEffect(0.4, f);
            }
        ]);
    }
};

cleverapps.styles.comicses = {};